import script from "./FocusModeDeleteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FocusModeDeleteModal.vue?vue&type=script&setup=true&lang=ts"

import "./FocusModeDeleteModal.vue?vue&type=style&index=0&id=62564122&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62564122"]])

export default __exports__